var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHydration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4961 12C15.4961 15.2012 12.7019 18 8.99609 18C5.29029 18 2.49609 15.2012 2.49609 12C2.49609 9.95029 3.63481 7.37257 5.27674 5.20908C6.0764 4.15541 6.92662 3.29348 7.68474 2.71586C8.06309 2.4276 8.3869 2.23433 8.64153 2.11918C8.86446 2.01836 8.9779 2.00282 8.99609 2.00043C9.01429 2.00282 9.12773 2.01836 9.35066 2.11918C9.60529 2.23433 9.9291 2.4276 10.3074 2.71586C11.0656 3.29348 11.9158 4.15541 12.7154 5.20908C14.3574 7.37257 15.4961 9.95029 15.4961 12ZM17.4961 12C17.4961 16.4183 13.6905 20 8.99609 20C4.30167 20 0.496094 16.4183 0.496094 12C0.496094 6.66667 6.16276 0 8.99609 0C11.8294 0 17.4961 6.66667 17.4961 12ZM6.34499 10.8517C6.44714 10.3089 6.08995 9.78615 5.5472 9.684C5.00444 9.58185 4.48164 9.93904 4.3795 10.4818C4.06458 12.1551 4.35939 13.6284 5.18746 14.7039C6.01661 15.7808 7.28614 16.3334 8.65586 16.3334C9.20814 16.3334 9.65586 15.8857 9.65586 15.3334C9.65586 14.7811 9.20814 14.3334 8.65586 14.3334C7.82986 14.3334 7.17812 14.011 6.77217 13.4838C6.36513 12.9551 6.11098 12.0951 6.34499 10.8517Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydration);
export default __webpack_public_path__ + "static/media/hydration.bc7bcbb1bff2d57fc41cd777dd28d8bb.svg";
export { ForwardRef as ReactComponent };